import { render, staticRenderFns } from "./TotalizadoresEmpresa.vue?vue&type=template&id=0b56e7de&"
import script from "./TotalizadoresEmpresa.vue?vue&type=script&lang=js&"
export * from "./TotalizadoresEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./TotalizadoresEmpresa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports